import uuid from 'uuid/v4';

import { Placement, ToastLevel, ToastType } from '@philips-emr/tws-constants';
import { MessageService, ToastService as TS } from '@philips-emr/tws-core/lib/services';
import { HttpStatus, RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';

interface RequestResponseToast extends RequestResponse {
  highlight?: boolean;
}

interface Toast {
  message: string;
  level: ToastLevel;
  highlight?: boolean;
}

class ToastService {

  private static toasHistory: [string?] = [];

  static open(arg: RequestResponse | Toast): void {

    const id = `tws-toast-service-${uuid()}`;
    let message;
    let level;
    let highlight = false;

    if (this.isRequestResponse(arg)) {

      if (Object.prototype.hasOwnProperty.call(arg, 'highlight')) {
        highlight = (arg as RequestResponseToast).highlight || false;
      }
      message = arg.body || MessageService.translate('hi.general-error');

      if (typeof message === 'object') {
        message = Object.values(message).shift() as string;
      }

      switch (arg.status) {
        case HttpStatus.OK:
        case HttpStatus.CREATED:
          level = ToastLevel.SUCCESS;
          break;
        case HttpStatus.BAD_REQUEST:
        case HttpStatus.UNAUTHORIZED:
        case 500:
        case 404:
          level = ToastLevel.ERROR;
          message = MessageService.translate('hi.general-error');
          break;
        default:
          level = ToastLevel.CAUTION;
      }
    } else {
      message = arg.message;
      level = arg.level;
      highlight = arg.highlight || false;
    }

    TS.open({
      id,
      dismissible: true,
      placement: Placement.TOP,
      type: ToastType.BUBBLE,
      showIcon: true,
      highlight,
      message,
      title: 'hi.warning',
      timeout: 7500,
      level,
    });

    if (this.toasHistory.length > 1) {
      TS.close(this.toasHistory.shift() ?? '');
    }

    this.toasHistory.push(id);
  }

  private static isRequestResponse(object: any): object is RequestResponse {
    return Object.prototype.hasOwnProperty.call(object, 'body');
  }
}

export {
  ToastService,
};
